import React, { useCallback } from 'react'

import NavigatableIntegrationWidgetCard from 'components/integrations/NavigatableIntegrationWidgetCard'
import { toTimePeriod } from 'util/date'
import { getFormattedPrice } from 'util/numbers'

export default function StripeSubscriptionRow({
  doNavigatableSetState,
  subscription,
}) {
  const {
    id,
    plan: {
      amount,
      currency,
      interval,
      interval_count: intervalCount,
      product: { name: productName } = {},
      nickname: planName,
    } = {},
  } =
    subscription || {}
  const onClick = useCallback(
    () => {
      doNavigatableSetState({ id, type: 'subscription' })
    },
    [doNavigatableSetState, id]
  )
  if (subscription)
    return (
      <NavigatableIntegrationWidgetCard.ListItem
        onClick={onClick}
        subTitle={`${getFormattedPrice(amount, currency)} ${toTimePeriod(
          interval,
          intervalCount
        )}`}
        title={planName || productName}
      />
    )
  return null
}
